import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCuteRobot: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCuteRobot"><Path d="M12 3.5H4.5V13.5H19.5V3.5H12ZM12 3.5V1.5M8.5 7.5V9.5M15.5 7.5V9.5M3.5 16.5L5.21124 14.7888M5.5 13.5V14.5V15C5.5 18.5899 8.41015 21.5 12 21.5C15.5899 21.5 18.5 18.5899 18.5 15V14.5V13.5M20.5 16.5L18.7888 14.7888" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCuteRobot;
